import { ApolloProvider } from "@apollo/client";
import AVC_AAA_client from "./apolloclient";

const ApolloClientProvider = ({ children }) => {
  return <ApolloProvider client={AVC_AAA_client}>{children}</ApolloProvider>;
};

export default ApolloClientProvider;
